export const isWebAuthnSupported = () =>
  !!(
    globalThis.PublicKeyCredential?.parseRequestOptionsFromJSON &&
    globalThis.navigator?.credentials?.get
  )

export const authenticateWebAuthn = (options) => {
  if (!isWebAuthnSupported()) {
    return Promise.reject(new Error('webauthn_not_supported'))
  }
  const publicKey = PublicKeyCredential.parseRequestOptionsFromJSON(options)
  return navigator.credentials.get({ publicKey }).then(
    (credential) => {
      if (!credential) return Promise.reject(new Error('no_credential'))
      return Promise.resolve(credential.toJSON())
    },
    (error) =>
      Promise.reject(error instanceof Error ? error : new Error(String(error))),
  )
}
